import React, {useEffect, useState} from "react";
import {Row, Col, Card, Button, Spin, message} from "antd";
import {ArrowLeftOutlined} from "@ant-design/icons";

import './TermosCondicoes.scss';
import TermosCondicoesText from "./TermosCondicoesText";
import GasMenino from '../../assets/images/gasmenino.png';
import { organizacaoService } from "../../shared/services/http/OrganizacaoService";
import {getUser} from "../../shared/services/UserService";
import {termosECondicoes} from "../../shared/services/TermosECondicoesService";

export default function TermosCondicoes({ history }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [organizacao, setOrganizacao] = useState({})
  const [accepting, setAccepting] = useState(false)
  const [declining, setDeclining] = useState(false)

  useEffect(() => getOrganization(),[])

  function getOrganization() {
    setLoading(true)
    organizacaoService.getById(getUser().id)
      .then(organization => setOrganizacao(organization))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }

  function accept() {
    setAccepting(true)
    organizacaoService.acceptTermsAndConditions()
      .then(() => getOrganization())
      .catch((error) => message.error(error))
      .finally(() => setAccepting(false))
  }

  function decline() {
    setDeclining(true)
    organizacaoService.declineTermsAndConditions()
      .then(() => getOrganization())
      .catch((error) => message.error(error))
      .finally(() => setDeclining(false))
  }

  function ActionContent({declined}) {
    const isSaving = accepting || declining

    return (
      <>
        <p>Para continuar, você precisa aceitar os <b>termos</b> e <b>condições</b></p>
        <Row type="flex" gutter={10}>
          <Col>
            <Button type="primary" loading={accepting} disabled={isSaving} onClick={() => accept()}>LI E ACEITO</Button>
          </Col>
          <Col>
            { !declined && <Button loading={declining} disabled={isSaving} onClick={() => decline()}>RECUSAR</Button>}
          </Col>
        </Row>
      </>
    )
  }

  function AlreadyAnsweredContent() {
    return (
      <>
        <p>Você já aceitou o documento de <b>termos</b> e <b>condições</b></p>
        <Row>
          <Col>
            <Button onClick={() => history.push('')} type="primary">IR PARA PEDIDOS</Button>
          </Col>
        </Row>
      </>
    )
  }

  function StatusContent() {

    const { Aceitou, Recusou } = termosECondicoes

    if (error) return <p>Falha ao carregar</p>;

    return (
      <Row type="flex" gutter={30}>
        <Col>
          <img src={GasMenino} alt="imagem gás menino" />
        </Col>
        <Col>
          {organizacao.termosECondicoes === Aceitou.Enum
            ? <AlreadyAnsweredContent />
            : <ActionContent declined={organizacao.termosECondicoes === Recusou.Enum} />
          }
        </Col>
      </Row>
    )
  }

  return (
    <div className="termos-condicoes">
      <div className="back-container light-blue mb-20 mt-20" onClick={() => history.push('')}>
        <ArrowLeftOutlined className="mr-10" type="arrow-left" />
        <b>Voltar</b>
      </div>

      <TermosCondicoesText />

      <Card bodyStyle={{ padding: "15px 50px" }} className="status-card" loading={loading}>
        <StatusContent />
      </Card>
    </div>
  )
}
